/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { BryntumGantt as BryntumGanttNative } from './bryntum-gantt-react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const BryntumGantt = ({ className, ganttRef, cls, ...props }) => {
  return (
    <BryntumGanttNative {...props} ref={ganttRef} cls={`${className} ${cls}`} />
  );
};
